import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataTable from '../UIElements/DataTable';
import { useDispatch } from 'react-redux';
import { appRequests } from '../../features/dashboard/dashboardSlice';

function ApplicationRequests() {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchParameters, setSearchParameters] = useState({
    // search: '',
    pageNumber: 0,
    pageSize: 10,
  });
  async function getDetails(data) {
    try {
      setLoading(true);
      const response = await dispatch(appRequests(data)).unwrap();
      setData(response?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  const columns = [
    {
      field: 'sno',
      headerName: <div className='text-sm'>SNO</div>,
      width: 70,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className=' cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'instituteId',
      headerName: <div className='text-sm'>Institute Id</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'instituteName',
      headerName: <div className='text-sm'>Institute Name</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'instituteType',
      headerName: <div className='text-sm'>Institute Type</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'fullName',
      headerName: <div className='text-sm'>full Name</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'designation',
      headerName: <div className='text-sm'>Designation</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'emailId',
      headerName: <div className='text-sm'>Email Id</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'phoneNumber',
      headerName: <div className='text-sm'>Phone number</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    {
      field: 'location',
      headerName: <div className='text-sm'>Location</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
  ];
  useEffect(() => {
    getDetails(searchParameters);
  }, [searchParameters]);
  return (
    <>
      <Typography variant='h6' className='text-[#1976d2] mb-2'>
        {' '}
        List of applicaiton requests
      </Typography>
      <Box
        sx={{
          overflowX: 'scroll', // always show scrollbar
          whiteSpace: 'nowrap', // prevent wrapping
          '&::-webkit-scrollbar': {
            height: '4px', // customize scrollbar height
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
          },
        }}
      >
        <div style={{ minWidth: '1200px' }}>
          <DataTable
            rows={(data?.applications || [])?.map((row, index) => ({
              sno:
                searchParameters.pageNumber * searchParameters.pageSize +
                index +
                1,
              ...row,
            }))}
            columns={columns}
            rowCount={data?.totalRecords || 0}
            paginationMode='server'
            page={searchParameters?.pageNumber}
            pageSize={searchParameters?.pageSize}
            loading={loading}
            hideColumnIcons={true}
            // onSortModelChange={(model) => {
            //   var filter = {};
            //   Object.entries(searchParameters).forEach(([key, value]) => {
            //     if (key !== 'sortAsc' && key !== 'sortDesc') {
            //       filter[key] = value;
            //     }
            //   });
            //   if (model?.[0]?.sort === 'desc') {
            //     filter['sortDesc'] = model?.[0]?.field;
            //   }
            //   if (model?.[0]?.sort === 'asc') {
            //     filter['sortAsc'] = model?.[0]?.field;
            //   }
            //   setSearchParameters({ ...filter });
            // }}
            onPageChange={(e) => {
              setSearchParameters((prev) => ({
                ...prev,
                pageNumber: e?.page,
                pageSize: e?.pageSize,
              }));
            }}
            // onFilterModelChange={(e) => {
            //   // Debounce filter changes to avoid rapid API calls
            //   if (e?.items[0]?.field) {
            //     if (window._studentFilterDebounce) {
            //       clearTimeout(window._studentFilterDebounce);
            //     }
            //     window._studentFilterDebounce = setTimeout(() => {
            //       setSearchParameters((prev) => ({
            //         ...prev,
            //         column: e?.items[0]?.field,
            //         operator: e?.items[0]?.operator,
            //         value: e?.items[0]?.value,
            //       }));
            //     }, 400);
            //   }
            // }}
          />
        </div>
      </Box>
    </>
  );
}

export default ApplicationRequests;
